<common-header [title]="title" [items]="items"></common-header>
<app-general-edit-egm [isEditEgm]="true" [isEdit]="isEdit" [idClone]="idClone" [isCreateEgm]="isCreateEgm">
</app-general-edit-egm>
